// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-page{padding:10px;position:relative}.chat-page .desc{margin-top:40px}.chat-page h1{margin-top:30px}.chat-page .chat{min-height:400px;position:relative;top:0;width:100%}.chat-page .chat .chat-smiles{max-width:400px}.chat-page .chat .chat-area{height:calc(100% - 133px)}.chat-page .chat .chat-area .messages{height:calc(100% - 43px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
